// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"280":"component---src-pages-index-old-js","532":"styles","678":"component---src-pages-index-js"}[chunkId] + "-" + {"280":"6275e091d39a592a56d2","532":"ef3b7d4ec13f3a025ce3","678":"caa5ffa849703ef2f882"}[chunkId] + ".js";
};